import {Dialog, Transition} from "@headlessui/react";
import {Fragment, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {createItem, getList} from "../../services/service";
import {selectUser} from "../../features/user/userSlice";
import ComboboxComponent from "../Combobox";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

export default function ModalAddProfileSystemAccessories({
                                                             open,
                                                             setOpen,
                                                             treeSelectId,
                                                             fetchData
                                                         }) {
    const cancelButtonRef = useRef(null);
    const [handleTypeList, setHandleTypeList] = useState([]);
    const [openingTypeList, setopeningTypeList] = useState([]);
    const [articleList, setArticleList] = useState([]);
    const [supplierList, setSupplierList] = useState([]);
    const [accessoriesList, setAccessoriesList] = useState([]);

    const [productId, setProductId] = useState(null);
    const [supplierId, setSupplierId] = useState(null);
    const [accessoryId, setAccessoryId] = useState(null);
    const [openingType, setOpeningType] = useState(null);
    const [handleType, setHandleType] = useState(null);


    const {token} = useSelector(selectUser);
    const {t} = useTranslation();
    const navigate = useNavigate();

    const fetchDataOpeningTypeList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/accessories/enum/opening/type`,
            token
        );
        if (response.success) {
            setopeningTypeList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name,
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };


    const fetchDataHandleTypeList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/accessories/enum/handle/type`,
            token
        );
        if (response.success) {
            setHandleTypeList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name,
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataAccessoriesList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/list`,
            token
        );
        if (response.success) {
            setAccessoriesList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataArticleList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/article`,
            token
        );
        if (response.success) {
            setArticleList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.article}`),
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    const fetchDataSupplierList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/supplier/list`,
            token
        );
        if (response.success) {
            setSupplierList(
                response.data.map((item) => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                    };
                })
            );
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (open) {
            // fetchDataSupplierList();
            // fetchDataArticleList();
            fetchDataAccessoriesList();
            fetchDataOpeningTypeList();
            fetchDataHandleTypeList();
        }
    }, [open]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onInsert = () => {
        (async () => {
            let data = {
                accessoryId: accessoryId,
                openingType: openingType,
                handleType: handleType,
                productId: productId,
                supplierId: supplierId,
                profileSystemId: treeSelectId,
            };
            let url = `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/accessories`;
            let response = await createItem(url, token, data);
            if (response.success) {
                fetchData();
                setOpen(false);
                toast.success(t('action.add_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            }
        })();
    };

    const handle_handle_type = (value) => {
        setHandleType(value.value);
    };

    const handle_opening_type = (value) => {
        setOpeningType(value.value);
    };

    const handle_accessories = (value) => {
        setAccessoryId(value.id);
    };

    const handle_supplier = (value) => {
        setSupplierId(value.id);
    };

    const handle_article = (value) => {
        setProductId(value.id);
    };

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setOpen}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"/>
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className="relative px-4 pt-5 pb-4 text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                <div>
                                    <div className="">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-lg font-medium leading-6 text-gray-900"
                                        >
                                            {t('add_profile_system_accessories')}
                                        </Dialog.Title>
                                        <div className="mt-8">
                                            <div className="mt-3">
                                                <ComboboxComponent
                                                    label={t('accessories')}
                                                    data={accessoriesList}
                                                    onChange={handle_accessories}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <ComboboxComponent
                                                    label={t('openingType')}
                                                    data={openingTypeList}
                                                    onChange={handle_opening_type}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <ComboboxComponent
                                                    label={t('handleType')}
                                                    data={handleTypeList}
                                                    onChange={handle_handle_type}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-8 sm:mt-10 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                                        onClick={onInsert}
                                    >
                                        {t('save')}
                                    </button>
                                    <button
                                        type="button"
                                        className="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
                                        onClick={() => setOpen(false)}
                                        ref={cancelButtonRef}
                                    >
                                        {t('cancel')}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
